import { render, staticRenderFns } from "./bnvtag.vue?vue&type=template&id=46a969e4&"
import script from "./bnvtag.vue?vue&type=script&lang=js&"
export * from "./bnvtag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports